import classNames from 'classnames';
import * as React from 'react';
import InputIcon from '../common/InputIcon';
import { ISmartInputProps } from './SmartInput2';

export interface ISearchInputProps {
  onSearch: () => void
  value: string
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void
  onChanged?: (arg: string) => void
  onClear?: () => void
  placeholder?: string
  className?: string
  innerRef?: React.RefObject<HTMLInputElement>
}

export default class SearchInput extends React.PureComponent<ISearchInputProps & ISmartInputProps, any> {

  public debouncedCall

  constructor(props) {
    super(props);
    this.state = {
      isFocus: false,
    };
  }

  componentDidMount() {
    if (this.props.autoFocus) setTimeout(() => this.props.innerRef.current.focus());
  }

  onChange = (e) => {
    let value: string = e.target.value;
    if (this.props?.onChanged) this.props.onChanged(value);
  }

  onFocus = (e) => {
    if (this.props?.onFocus) this.props?.onFocus(e);
    this.setState({isFocus: true});
  }

  onIconClick = () => {
    if (this.props.onClear && this.props.value) this.props.onClear();
  }

  onKeyPress = (e) => { if (e.key === "Enter") this.props.onSearch(); }

  onBlur = () => this.setState({isFocus: false});

  public render() {
    return (
      <div className={this.props.className || ""}>
        <InputIcon  leftIcon={<i onClick={this.onIconClick} className={classNames({"fas fa-search": !this.props.value, "pointer fas fa-times": !!this.props.value, "is-focus": this.state.isFocus})} />} >
          <input className="form-control" onKeyPress={this.onKeyPress} ref={this.props.innerRef} placeholder={this.props.placeholder} value={this.props.value} onChange={this.onChange} onFocus={this.onFocus} onBlur={this.onBlur} />
        </InputIcon>
      </div>
    );
  }
}
